/**
 * Round 16 H25 / H27 -- the source tag before a letter's title.
 *
 * Three surfaces printed "[SAMA]", "[SAMA-DEMO]" or "[INTERNAL]" hard
 * against the title with only a margin between them, so the text read
 * "[INTERNAL]Remediate ..." to a screen reader and a copy. The tag now
 * carries its own space, and the internal source -- a plan the bank
 * raised on itself, not a regulator's letter -- is said in words.
 */
import { useTranslation } from "react-i18next";

export const INTERNAL_REGULATOR_CODE = "INTERNAL";

export function RegulatorTag({
  code,
  className = "text-xs text-slate-500",
}: {
  code: string | null | undefined;
  className?: string;
}) {
  const { t } = useTranslation();
  if (!code) return null;
  return (
    <>
      <span data-testid="regulator-tag" className={className}>
        {code === INTERNAL_REGULATOR_CODE ? t("letters.internalSource") : `[${code}]`}
      </span>{" "}
    </>
  );
}
